import { render, staticRenderFns } from "./PageFullWidth.vue?vue&type=template&id=32d5826f&"
import script from "./PageFullWidth.vue?vue&type=script&lang=js&"
export * from "./PageFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports